import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {CarePlanServiceDgSerachResults} from "../models/datagrid-search-results/care-plan-service.dg-serach-results.model";
import {CarePlanServicesService} from "../providers/care-plan-services.service";

@Injectable()
export class CarePlanServiceResolve implements Resolve<CarePlanServiceDgSerachResults> {
  constructor(private carePlanServicesService: CarePlanServicesService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<CarePlanServiceDgSerachResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.carePlanServicesService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
